import * as Icons from "lucide-react";

// Resolve a lucide icon by name with a safe fallback.
export function LucideIcon({ name, ...props }) {
  const C = Icons[name] || Icons.Square;
  return <C {...props} />;
}
